import React, { useCallback, useMemo, useState } from 'react';
import { Spin, Icon } from 'antd';
import { Table, Button } from '../../../components/ui';
import { format } from 'date-fns';
import AuthorizedDomainForm from './AuthorizedDomainForm';
import { useGetAuthorizedDomains } from 'query/admin';
import ESPRenderer from '../../../components/blocks/ESPRenderer';

export default function AuthorizedDomains() {
  const [visible, setVisible] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const { data: gSuiteDomains, isLoading } = useGetAuthorizedDomains();

  const handleHideForm = () => {
    setVisible(false);
    setSelectedDomain(null);
  };

  const handleShowForm = () => setVisible(true);

  const handleSelectDomain = useCallback(
    domain => () => {
      setSelectedDomain(domain);
      setVisible(true);
    },
    [setVisible],
  );

  const columns = useMemo(() => {
    return [
      {
        title: 'Domain',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Service',
        dataIndex: 'esp',
        key: 'esp',
        render: esp => {
          return <ESPRenderer esp={esp} />;
        },
      },
      {
        title: 'Last Updated',
        align: 'center',
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        render: updatedAt => format(new Date(updatedAt), 'yyyy-MM-dd HH:mm'),
      },
      {
        title: 'Is Active',
        align: 'center',
        dataIndex: 'isActive',
        key: 'isActive',
        render: isActive => (
          <div>
            {isActive ? (
              <Icon type="check" />
            ) : (
              <Icon theme="filled" type="close-circle" />
            )}
          </div>
        ),
      },
      {
        key: 'actions',
        align: 'center',
        render: (value, row) => {
          return (
            <div
              className="flex items-center space-x-2"
              style={{ justifyContent: 'center' }}
            >
              <Button onClick={handleSelectDomain(row)}>Update Domain</Button>
            </div>
          );
        },
      },
    ];
  }, [handleSelectDomain]);

  return (
    <Spin spinning={isLoading}>
      <Button style={{ marginBottom: 10 }} onClick={handleShowForm}>
        Add Authorized Domain
      </Button>

      {visible && (
        <AuthorizedDomainForm
          domainInfo={selectedDomain}
          visible={visible}
          onHideForm={handleHideForm}
        />
      )}

      <Table
        columns={columns}
        dataSource={gSuiteDomains || []}
        pagination={false}
        rowKey="name"
      />
    </Spin>
  );
}
